import axios from './http'

// 新增用户
export const PostAddUser = params => {
    return axios.post("/user/add", params).then(res => res.data)
};
// 修改用户
export const PutEditUser = params => {
    return axios.put("/user/update", params).then(res => res.data)
};
// 删除用户
export const DelUser = userId => {
    return axios.delete(`/user/remove/${userId}`).then(res => res.data)
};

// 查询用户列表
export const GetUserList = query => {
    return axios.get("/user/list", {params: query}).then(res => res.data)
};
